<template>
  <components
    ref="form"
    :is="config.name"
    :mode="mode"
    v-model="_value"
    v-bind="config.props"
    :config1="config"
    :name="name"
    @input="input"
  />
</template>
<script>
import components from '@/views/common/form/ComponentExport'

export default {
  name: 'FormRender',
  components: components,
  props: {
    name:{
      default: null,
    },
    mode: {
      type: String,
      default: 'DESIGN',
    },
    value: {
      default: undefined,
    },
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  created() {
    console.log(123456789)
    console.log(this.mode, 'mode')
    console.log(this._value, '_value')
    console.log(this.name, 'name')
    console.log(this.config, 'config')
    // const Copy = Object.assign({}, this.config);
    // const Copy = JSON.parse(JSON.stringify(this.config));
    // this.config1 = Copy;
    // console.log(this.config1, "config1");
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  data() {
    return { config1: {} }
  },
  methods: {
    validate(call) {
      this.$refs.form.validate(call)
    },
    input(val) {
      this._value = val
      console.log(this._value, 'Pval')
    },
  },
}
</script>

<style lang="less" scoped></style>
